<template>
  <div class="">
    <section class="is-small">
      <div class="container">
        <nav class="navbar">
          <a
            @click="$router.go(-1)"
            class="navbar-item"
          >
            <span class="icon is-small">
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
            </span>
            <span>Back</span>
          </a>
        </nav>
      </div>
    </section>

    <transition
      name="fade"
      mode="out-in"
    >
      <ui-loader
        v-if="isLoading"
        key="loading"
        class="has-padding has-text-centered"
      />

      <div
        v-if="!isLoading"
        key="detailpage"
      >
        <div class="voucher-info">
          <section class="is-small">
            <BasicData
              :voucher="voucher"
              :voucherId="voucherId"
              class="container"
            />
          </section>

          <section class="is-small">
            <Settings
              :voucher="voucher"
              :voucherId="voucherId"
              class="container"
            />
          </section>

          <section
            v-if="voucher.Type === 'Package'"
            class="is-small"
          >
            <div class="container">
              <SpacePrice />
            </div>
          </section>
          <YieldList
            v-if="voucher.Type !== 'Package'"
            :voucherId="voucherId"
            :channelId="channelId"
            :locationId="locationId"
            :yieldList="voucher.Prices"
          />

          <section class="is-small">
            <Options
              :voucherId="voucherId"
              class="container"
            />
          </section>

          <section
            v-if="voucher.Type !== 'Package'"
            class="is-small"
          >
            <div class="container">
              <div class="columns">
                <div class="column">
                  <Profiles
                    :voucher="voucher"
                    :voucherId="voucherId"
                  />
                </div>
              </div>
            </div>
          </section>

          <section class="is-small">
            <div class="container">
              <div class="columns">
                <div class="column">
                  <Locations
                    :voucher="voucher"
                    :voucherId="voucherId"
                  />
                </div>
                <div class="column"></div>
              </div>
            </div>
          </section>

          <!-- Publication settings -->

          <section
            v-if="voucher.Type === 'Package'"
            class="is-small mb-4"
          >
            <Images
              :voucher="voucher"
              :voucherId="voucherId"
              class="container"
            />
          </section>

          <section
            v-if="voucher.Type === 'Package'"
            class="is-small mb-4"
          >
            <Texts class="container" />
          </section>

          <section
            v-if="voucher.Type === 'Package'"
            class="section is-small mb-4"
          >
            <Channels
              :voucher="voucher"
              :voucherId="voucherId"
              class="container"
            />
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import voucherProvider from '@/providers/voucher'
import BasicData from '@/components/Vouchers/BasicData'
import Settings from '@/components/Vouchers/Settings'
import Options from '@/components/Vouchers/Options'
import Profiles from '@/components/Vouchers/Profiles'
import Locations from '@/components/Vouchers/Locations'
import SpacePrice from '@/components/Vouchers/SpacePrice'
import YieldList from '@/components/Yield/YieldList'

import Channels from '@/components/Vouchers/Channels'
import Texts from '@/components/Vouchers/Texts'
import Images from '@/components/Vouchers/Images'

export default {
  props: {},

  components: {
    BasicData,
    Settings,
    Options,
    Profiles,
    Locations,
    SpacePrice,
    YieldList,
    Images,
    Channels,
    Texts,
  },

  data() {
    return {
      isLoading: true,
      locationId: this.$route.params.locationId
        ? Number(this.$route.params.locationId)
        : 0,
      voucherId: Number(this.$route.params.voucherId),
    }
  },

  computed: {
    ...mapState('channelStore', ['channel']),
    ...mapState('voucherStore', ['voucher']),
  },

  created() {
    // Get voucher data
    this.getVoucher()
  },

  beforeDestroy() {
    this.setVoucher(null)
  },

  methods: {
    ...mapMutations('menuStore', ['setSelectedMenuItemIndex']),
    ...mapMutations('voucherStore', ['setVoucher']),

    /**
     * Get voucher data
     */
    getVoucher() {
      let self = this
      voucherProvider.methods.getVoucherById(this.voucherId, this.locationId)
        .then((response) => {
          if (response.status === 200) {
            self.setVoucher(response.data)
          }
        })
        .catch(() => { })
        .finally(() => {
          self.isLoading = false
        })
    },
  },
}
</script>
